export const eventActions = {
    USER_ACTIVE: "USER_ACTIVE",
    USER_INACTIVE: "USER_INACTIVE"
};